import { render, staticRenderFns } from "./x-password-dialog.vue?vue&type=template&id=71228a76"
import script from "./x-password-dialog.vue?vue&type=script&lang=js"
export * from "./x-password-dialog.vue?vue&type=script&lang=js"
import style0 from "./x-password-dialog.vue?vue&type=style&index=0&id=71228a76&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports